import { type VariantProps, cva } from "class-variance-authority";
import { ElementType, forwardRef } from "react";
import { HStack } from "./layout/stack";
import { cn } from "./lib/utils";

const pillVariants = cva(
	"rounded-md px-sm py-min text-xs uppercase items-center",
	{
		variants: {
			variant: {
				default: "text-email-background bg-white/60",
				brand: "bg-jace text-email-background",
				calendar: "text-message-webagent-background bg-text-body-inverted",
			},
		},
		defaultVariants: {
			variant: "default",
		},
	},
);

interface PillProps extends VariantProps<typeof pillVariants> {
	children?: React.ReactNode | number;
	className?: string;
	ele?: ElementType;
}

export const Pill = forwardRef<HTMLDivElement, PillProps>(
	(
		{ children, className, variant = "default", ele },
		ref,
	): React.ReactElement => {
		return (
			<HStack
				className={cn(pillVariants({ variant }), "inline-flex", className)}
				ref={ref}
				ele={ele}
			>
				{children}
			</HStack>
		);
	},
);

Pill.displayName = "Pill";
